<template>
    <ac-modal title="Update User" ref="modalRef" :size-class="'modal-md'">
        <template>
            <div v-if="viewOnly" class="row">
                <div class="col-md-12">
                    <div class="alert alert-info">
                        This profile has not been completed and their password cannot yet be updated.
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-md-12 form-group">
                    <label for="Username">New Username</label>
                    <input type="text" id="Username" class="form-control" :placeholder="userName"  v-model="userData.userName">
                </div>
                <div class="col-md-12 form-group">
                    <label for="Password">New Password</label>
                    <input type="text" id="Password" class="form-control" v-model="userData.password">
                </div>
                <div class="col-md-12">
                    <div class="button-box">
                        <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                        <ac-button class="btn btn-sm btn-green" :action="updateUser">Update</ac-button>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "UpdateUserModal",
        data() {
            return {
                viewOnly: false,
                userData: {},
                userName: ""
            };
        },
        async mounted() {

        },
        methods: {
            showModal(userData) {
                this.userData = userData;
                this.userName = userData.userName;
                this.viewOnly = userData.viewOnly || false;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async updateUser() {
                let self = this;
                let result = await api.post('Admin', 'UpdateUserPassword', self.userData);
                if(result) {
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>